// extracted by mini-css-extract-plugin
module.exports = {"outer":"Slider_outer__36F24","slider":"Slider_slider__3c1Ge","sliderlabel":"Slider_sliderlabel__1eZvo"};